module.exports = __webpack_public_path__ + "static/media/Bumppy Payments1.e41c0d69.png";